// Story system (Milestone 2.5) — ordered text fragments with metric-based unlocks.
// Each sentence has a single unlock rule; any one satisfied rule reveals it.

export interface StorySentence {
  text: string
  unlock: StoryRule
}

export type StoryRule =
  | { type: 'heat'; min?: number; max?: number }
  | { type: 'weight'; min?: number; max?: number }
  | { type: 'length'; min: number }

export const STORY: StorySentence[] = [
  { text: "The first letter stirs in darkness, cold and unnamed.", unlock: { type: 'length', min: 20 } },
  { text: "Fresh ink pools on the type as vowels find their voice.", unlock: { type: 'heat', min: 40 } },
  { text: "The roller presses down. Each consonant leaves its mark.", unlock: { type: 'weight', min: 30 } },
  { text: "Words stack upon words, a tower of ink and intent.", unlock: { type: 'length', min: 60 } },
  { text: "The press runs deep. Letters saturate before they are read.", unlock: { type: 'heat', min: 70 } },
  { text: "Balance shifts. Light letters flutter while heavy type anchors.", unlock: { type: 'weight', min: 50 } },
  { text: "A sentence takes shape. Not yet complete, but alive.", unlock: { type: 'length', min: 100 } },
  { text: "The ink begins to dry. Patience is its own refreshment.", unlock: { type: 'heat', min: 90 } },
  { text: "Every impression matters — even the spaces between.", unlock: { type: 'weight', min: 70 } },
  { text: "The alphabet breathes. Each glyph a creature, each word a world.", unlock: { type: 'length', min: 150 } },
]

export function evaluateStoryRules(
  heat: number,
  weight: number,
  totalLength: number,
  unlocked: number[],
): number[] {
  const newlyUnlocked: number[] = []
  for (let i = 0; i < STORY.length; i++) {
    if (unlocked.includes(i)) continue
    const rule = STORY[i].unlock
    let satisfied = false
    if (rule.type === 'heat') {
      satisfied = (rule.min == null || heat >= rule.min) && (rule.max == null || heat <= rule.max)
    } else if (rule.type === 'weight') {
      satisfied = (rule.min == null || weight >= rule.min) && (rule.max == null || weight <= rule.max)
    } else if (rule.type === 'length') {
      satisfied = totalLength >= rule.min
    }
    if (satisfied) newlyUnlocked.push(i)
  }
  return newlyUnlocked
}
